<div [ngClass]="fuseConfig.theme.layout.navbar.primaryBackground">
    <fuse-navigation layout="horizontal"></fuse-navigation>
</div>